import { Component , OnInit, OnDestroy} from '@angular/core';
declare var QCELL: any;
declare function menuClick(): any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy  {
  title = 'qcell_angular_demo';

  constructor() {}

  ngOnInit(): void {
    QCELL.create({
      id  : 'qcell1',
      parentid    : 'sheetarea1',
      data    : {'input': [{"name":"Hello","message":"큐셀!","etc":"가장 간단한 첫번째 큐셀 그리드입니다."}]},
      columns :  [
          {key: 'name', type:'input', title: ['컬럼1'], width: "20%"}
          , {key: 'message', title: ['컬럼2'], width: "30%"}
          , {key: 'etc', title: ['컬럼3'], width: "50%"}
       ]
      })
  }

  ngOnDestroy(): void {
    console.log('destroy')
  }
}
